import React from "react";
import { DealsQuestionnaireData } from "@/pages/deals/types";
import { ScoreType, ScoreConfig } from "@/pages/deals/scoreConfig";
import { isNull } from "lodash";
import { useTranslation } from "react-i18next";
import WorkflowScore from "@/pages/deals/components/DealStages/components/WorkflowScore";
import WorkflowSelectorButton from "@/components/shared/WorkflowSelectorButton";

interface Props {
  questionnaire: DealsQuestionnaireData;
  isSelected: boolean;
  isCurrentStage: boolean;
  onClick: () => void;
  isLoadingScore?: boolean;
  pocQuestionnaireName?: string;
}

const QuestionnaireButton: React.FC<Props> = ({
  questionnaire,
  isSelected,
  isCurrentStage,
  onClick,
  isLoadingScore = false,
  pocQuestionnaireName
}) => {
  const { t } = useTranslation();
  const { name, score, kpiValue } = questionnaire;

  const isStakeholdersApproval = kpiValue === ScoreType.STAKEHOLDERS_APPROVAL;
  const isGeneral = kpiValue === ScoreType.GENERAL;
  const isNotCompleted =
    score?.scoreText?.toLowerCase() === ScoreConfig.PENDING &&
    isNull(score.scoreResult);

  const label =
    isStakeholdersApproval && pocQuestionnaireName
      ? t("deals.dealView.stakeholdersApprovalName", {
          name,
          pocName: pocQuestionnaireName
        })
      : name;

  return (
    <WorkflowSelectorButton
      label={label}
      isSelected={isSelected}
      isCurrentStage={isCurrentStage}
      onClick={onClick}
      rightAdornment={
        <WorkflowScore
          isLoadingScore={isLoadingScore}
          isNotCompleted={isNotCompleted}
          isGeneral={isGeneral}
          isStakeholdersApproval={isStakeholdersApproval}
          scoreText={score?.scoreText || ""}
          scoreType={kpiValue as ScoreType}
          size="sm"
        />
      }
    />
  );
};

export default QuestionnaireButton;
